import createVueComponent from '../createVueComponent';

const ArrowDownRightFromCircle = createVueComponent(
  'ArrowDownRightFromCircleIcon',
  [
    ['path', { d: 'M12 22a10 10 0 1 1 10-10', key: '130bv5' }],
    ['path', { d: 'M22 22 12 12', key: '131aw7' }],
    ['path', { d: 'M22 16v6h-6', key: '1gvm70' }],
  ],
);

export default ArrowDownRightFromCircle;
